import * as React from 'react';

import type {EventFragmentSparse, SessionUser} from 'nutshell-graphql-types';

import {TimelineBannerOutreachSent} from '../banner';

import {TimelineEntryEmail, TimelineEntryInboxThread} from '.';

export function getEmailTimelineEvent(input: {
    event: EventFragmentSparse;
    currentUser: SessionUser;
    onDelete?: (eventId: string, allById?: boolean) => Promise<any>;
    hasGutterLine?: boolean;
    isDashboard?: boolean;
    refetchEvents: () => Promise<any> | null | undefined;
    isFirstEmail: boolean;
    entityPageId?: string | null | undefined;
    onFilterOutEvent?: () => void;
}) {
    const {
        event,
        currentUser,
        onDelete,
        hasGutterLine,
        isDashboard,
        refetchEvents,
        isFirstEmail,
        entityPageId,
        onFilterOutEvent,
    } = input;

    // @ts-expect-error
    if (event.payload.isNutshellMarketingEmail) {
        return <TimelineBannerOutreachSent key={event.id} event={event} />;
    }

    return (
        <TimelineEntryEmail
            key={event.id}
            event={event}
            currentUser={currentUser}
            onDeleteEvent={onDelete}
            hasGutterLine={hasGutterLine}
            isDashboard={isDashboard}
            refetchEvents={refetchEvents}
            entityPageId={entityPageId}
            onFilterOutEvent={onFilterOutEvent}
            allowSuggestedReplies={
                isFirstEmail &&
                event.payload.__typename === 'Email' &&
                event.payload.sentWithinLastWeek &&
                !event.payload.hasAcceptedSuggestion
            }
        />
    );
}

export function getThreadTimelineEvent(input: {
    event: EventFragmentSparse;
    entityPageId: string | null | undefined;
    entityPageName: string | null | undefined;
}) {
    const {event, entityPageId, entityPageName} = input;

    return (
        <TimelineEntryInboxThread
            key={event.id}
            event={event}
            entityPageId={entityPageId}
            entityPageName={entityPageName}
        />
    );
}
